import { DateFormatter } from '@repo/toolkit/date'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { ArrowLeftRight } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { toast } from 'sonner'

import { createCenterOlPayment } from '../../api/center-ol-payments/create-center-ol-payment'
import UserNavBar from '../../components/elements/nav-bar'
import { CenterOlPaymentForm } from '../../components/pages/center-ol-payments/center-ol-payment-form'
import { Paths } from '../../lib/constants/path'
import { updateButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

export function CenterOlPaymentsCreatePage() {
  const { navigate } = useNavigator()
  const [formKey, setFormKey] = useState(0)

  const { mutateAsync: createCenterOlPaymentMutation } = useMutation({
    mutationFn: createCenterOlPayment,
    mutationKey: ['create-center-ol-payment'],
    onError: showAxiosError,
    onSuccess: () => toast.success('Virement créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un virement'} icon={ArrowLeftRight} />
      <div className={'h-4'} />
      <Box>
        <CenterOlPaymentForm
          key={formKey}
          mode="default"
          defaultValues={{ dateOfPayment: DateFormatter.toDateFormatted(new Date()) }}
          buttonsConfig={updateButtonsConfig({
            onCancel: () => navigate(Paths.CENTER_OL_PAYMENTS_LIST_PAGE),
            onUpdate: async (values) => {
              const response = await createCenterOlPaymentMutation(values)
              navigate(Paths.CENTER_OL_PAYMENTS_UPDATE_PAGE.replace(':id', response.id.toString()))
            },
            onUpdateThenCreate: async (values) => {
              await createCenterOlPaymentMutation(values)
              setFormKey((prev) => prev + 1)
            },
            onUpdateThenList: async (values) => {
              await createCenterOlPaymentMutation(values)
              navigate(Paths.CENTER_OL_PAYMENTS_LIST_PAGE)
            }
          })}
        />
      </Box>
    </div>
  )
}
